import { render } from "./mobile-two.vue?vue&type=template&id=1834d461&scoped=true"
import script from "./mobile-two.vue?vue&type=script&lang=js"
export * from "./mobile-two.vue?vue&type=script&lang=js"

import "./mobile-two.vue?vue&type=style&index=0&id=1834d461&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1834d461"]])

export default __exports__